<!-- 由 suu 创建于 2022-06-30 星期四 -->
<template>
  <div class="ques-date">
    <div class="title">{{ curQues.field_title }}</div>
    <div class="date-text" @click="show = true"
      >{{ dateText || '请选择生日' }} <van-icon class="date-icon" name="play"
    /></div>
    <van-overlay class="date-picker" :show="show" @click="show = false">
      <div class="picker-region" @click.stop>
        <van-datetime-picker
          v-model="currentDate"
          @confirm="handelChange"
          @cancel="show = false"
          type="date"
          title="选择年月日"
          :min-date="minDate"
          :max-date="maxDate"
        />
      </div>
    </van-overlay>
  </div>
</template>

<script>
import DATE from '@/common/date.js'
export default {
  name: 'ques-date',

  components: {},

  props: {
    curQues: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },

  data() {
    return {
      show: false,
      dateText: '',
      minDate: new Date(1940, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(1995, 0, 1)
    }
  },

  computed: {},

  watch: {},

  created() {
    if (this.curQues.value) {
      this.dateText = this.curQues.value
      this.currentDate = new Date(this.dateText.replace(/-/g, '/'))
    }
  },

  mounted() {},

  destroyed() {},

  methods: {
    handelChange(value) {
      this.dateText = DATE.formatDate(value)
      this.show = false
      this.$emit('change', this.dateText)
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.ques-date {
  flex: 1;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  .title {
    font-size: 22px;
    font-weight: 600;
    color: #202539;
    line-height: 32px;
  }
  .date-text {
    text-align: center;
    width: 204px;
    height: 44px;
    box-sizing: border-box;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 22px;
    border: 3px solid #373d52;
    font-size: 18px;
    font-weight: 600;
    color: #373d52;
    margin-top: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
    .date-icon {
      transform: rotate(90deg);
      margin-right: -10px;
      margin-left: 5px;
    }
  }
  .date-picker {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: end;
    box-sizing: border-box;
    @include paddingBottom();
    .picker-region {
      width: 100%;
      box-sizing: border-box;
      position: absolute;
      left: 0;
      @include fixedBottom();
    }
    ::v-deep {
      .van-picker {
        width: 100%;
        box-sizing: border-box;
      }
    }
  }
}
</style>
